const getToggleMap = () => {
  const togglesEl = document.getElementById('bp-feature-toggles');

  if (!togglesEl?.value) {
    return {};
  }

  return JSON.parse(togglesEl.value);
};

const isToggleValueEnabled = (value) => value === 1 || value === true || value === '1';

const enabled = (feature) => isToggleValueEnabled(getToggleMap()[feature]);
const disabled = (feature) => !enabled(feature);

export default {
  enabled,
  disabled,
};
